<div class="app-global-search" [class.app-global-search-collapsed]="collapsed()" [class.app-global-search-active]="search.onResultsRoute()">
	@if (!collapsed()) {
		<p-iconfield iconPosition="right" class="app-global-search-field">
			<input
				#searchInput
				type="text"
				pInputText
				autocomplete="off"
				spellcheck="false"
				class="p-inputtext-sm app-global-search-input"
				[ngModel]="search.query()"
				(ngModelChange)="search.setQuery($event)"
				(keyup.enter)="onSubmit()"
				(keyup.escape)="onClear()"
				[placeholder]="placeholder"
				[pTooltip]="tooltip"
				tooltipPosition="right"
				aria-label="Global search"
				data-testid="globalSearchInput" />
			@if (search.hasQuery()) {
				<button type="button" class="app-global-search-clear" (click)="onClear()" aria-label="Clear search" data-testid="globalSearchClear">
					<i class="pi pi-times"></i>
				</button>
			}
			<button type="button" class="app-global-search-submit" (click)="onSubmit()" aria-label="Run search" data-testid="globalSearchSubmit">
				<i class="pi pi-search"></i>
			</button>
		</p-iconfield>
	} @else {
		<button
			type="button"
			class="app-global-search-collapsed-btn"
			(click)="onExpandAndFocus()"
			[pTooltip]="placeholder"
			tooltipPosition="right"
			aria-label="Open global search"
			data-testid="globalSearchCollapsed">
			<i class="pi pi-search"></i>
		</button>
	}
</div>
